import { render, staticRenderFns } from "./individual_school_management_detail.vue?vue&type=template&id=150a68fc&scoped=true&"
import script from "./individual_school_management_detail.vue?vue&type=script&lang=js&"
export * from "./individual_school_management_detail.vue?vue&type=script&lang=js&"
import style0 from "./individual_school_management_detail.vue?vue&type=style&index=0&id=150a68fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a68fc",
  null
  
)

export default component.exports